import * as React from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Stack,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { startLoading, stopLoading } from '../../../store/slices/loaderSlice';
import { getQr, uploadSlip } from './helper/rupayUPIApi';

export default function RupayUpiLoadRequest() {
  const dispatch = useDispatch();

  const [formData, setFormData] = React.useState({
    mobile: '',
    name: '',
    amount: '',
    txnId: '',
    slip: null,
    qrvendor: ''
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

  const handleSubmit = async (e) => {
    try {
      dispatch(startLoading());
      e.preventDefault();

      const res = await uploadSlip(formData);
      if (res.status === 'SUCCESS') {
        toast.success('Slip uploaded successfully!');
        setFormData({
          mobile: '',
          name: '',
          amount: '',
          txnId: '',
          slip: null,
          qrvendor: ''
        });
      } else {
        toast.error('Failed to upload slip. Please try again.');
        return;
      }
    } catch (error) {
      toast.error('An error occurred while uploading the slip. Please try again.');
    } finally {
      dispatch(stopLoading());
    }
  };

  const [currentQr, setCurrentQr] = React.useState(null);

  // fetch existing QR on load
  React.useEffect(() => {
    getQr()
      .then((data) => {
        if (data?.status) setCurrentQr(data.image_url);
      })
      .catch(console.error);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Card
        sx={{
          width: '100%',
          maxWidth: 1200,
          overflow: 'hidden',
          boxShadow: 6
        }}
      >
        <Grid container>
          {/* LEFT SIDE */}

          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                height: '100%',
                minHeight: { xs: 300, md: 650 },
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Box
                component="img"
                src={currentQr}
                alt="Payment"
                sx={{
                  width: '70%',
                  height: '70%'
                }}
              />
            </Box>
          </Grid>

          {/* RIGHT SIDE */}

          <Grid size={{ xs: 12, md: 6 }}>
            <CardContent
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}
            >
              <Typography variant="h4" fontWeight={700} mb={1}>
                Rupay UPI Load Wallet Request
              </Typography>

              <Typography variant="body2" color="text.secondary" mb={4}>
                Fill all required information carefully.
              </Typography>

              <Box component="form" onSubmit={handleSubmit}>
                <Stack spacing={3}>
                  <TextField
                    fullWidth
                    label="Mobile Number"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    inputProps={{
                      maxLength: 10,
                      inputMode: 'numeric',
                      pattern: '[0-9]*'
                    }}
                  />

                  <TextField fullWidth label="Full Name" name="name" value={formData.name} onChange={handleChange} />

                  <TextField
                    fullWidth
                    label="Amount"
                    name="amount"
                    type="number"
                    value={formData.amount}
                    onChange={(e) => {
                      const value = Number(e.target.value);

                      if (e.target.value === '' || value <= 100000) {
                        handleChange(e);
                      }
                    }}
                    inputProps={{
                      min: 1,
                      max: 100000
                    }}
                  />

                  <TextField
                    fullWidth
                    label="Transaction ID"
                    name="txnId"
                    value={formData.txnId}
                    onChange={(e) => {
                      if (e.target.value.length <= 12) {
                        handleChange(e);
                      }
                    }}
                    inputProps={{
                      maxLength: 12
                    }}
                  />

              
                  <Button component="label" variant="outlined" startIcon={<CloudUploadIcon />}>
                    Upload Payment Slip
                    <input hidden type="file" name="slip" accept="image/*" onChange={handleChange} />
                  </Button>

                  {formData.slip && (
                    <Typography variant="body2" color="text.secondary">
                      Selected: {formData.slip.name}
                    </Typography>
                  )}

                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{
                      textTransform: 'none',
                      //   fontSize: '1rem',
                      fontWeight: 600
                    }}
                  >
                    Submit
                  </Button>
                </Stack>
              </Box>
            </CardContent>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
}
